/**
 * Sticky stacking rows inside .group-block.sticky-rows
 * Sets --sticky-rows-top from the live header height.
 */
function getStickyRows(content) {
  /** @type {HTMLElement[]} */
  const rows = [];

  for (const child of content.children) {
    if (!(child instanceof HTMLElement)) continue;

    if (child.classList.contains('group-block') && child.classList.contains('sticky-row')) {
      rows.push(child);
      continue;
    }

    if (child.classList.contains('shopify-block')) {
      const inner = child.querySelector(':scope > .group-block.sticky-row');
      if (inner instanceof HTMLElement) rows.push(inner);
    }
  }

  return rows;
}

function updateStickyRowsTop(container) {
  const header = document.getElementById('header-component');
  const headerHeight = header instanceof HTMLElement ? header.offsetHeight : 0;
  container.style.setProperty('--sticky-rows-top', `${headerHeight + 24}px`);
}

function initStickyRows() {
  document.querySelectorAll('.group-block.sticky-rows').forEach((container) => {
    if (!(container instanceof HTMLElement)) return;

    const content = container.querySelector(':scope > .sticky-rows__content');
    if (!(content instanceof HTMLElement)) return;

    updateStickyRowsTop(container);

    const rows = getStickyRows(content);
    rows.forEach((row, index) => {
      row.style.setProperty('--sticky-row-index', String(index + 1));
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyRows, { once: true });
} else {
  initStickyRows();
}

document.addEventListener('shopify:section:load', initStickyRows);
window.addEventListener('resize', initStickyRows, { passive: true });
